import { render, staticRenderFns } from "./myHome.vue?vue&type=template&id=12f042af&scoped=true"
import script from "./myHome.vue?vue&type=script&lang=js"
export * from "./myHome.vue?vue&type=script&lang=js"
import style0 from "./myHome.vue?vue&type=style&index=0&id=12f042af&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f042af",
  null
  
)

export default component.exports